import React from "react";
import ProductIndex from "./components/ProductIndex";
import getFavItems from "../favourites/utils/getFavItems";
import {createRoot} from "react-dom/client";

export default () => {

    const dom = document.getElementById('product-category');
    if (dom) {
        const root = createRoot(dom);
        getFavItems().then((data) => {
            root.render(
                <ProductIndex
                    settings={JSON.parse(dom.getAttribute('data-settings'))}
                    url={dom.getAttribute('data-url')}
                    breadcrumbs={dom.getAttribute('data-breadcrumbs')}
                />
            );
        });
    }

}
